import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, Validators, FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { IDistrict } from 'src/app/interfaces/country';
import { DataService } from 'src/app/services/data.service';
import { pageKey, validSelected, autoComplete, pushToArray, toNumber } from 'src/app/services/mapping.service';
import { statusObj } from 'src/app/dummy/status';
import { Observable } from 'rxjs';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthService } from 'src/app/auth/auth.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-add-geo-district',
  templateUrl: './add-geo-district.component.html',
  styleUrls: ['./add-geo-district.component.scss']
})
export class AddGeoDistrictComponent implements OnInit {
  @ViewChild("focus", { static: false }) inputRef: ElementRef;

  form: FormGroup;
  code: AbstractControl;
  name: AbstractControl;
  province: AbstractControl;
  description: AbstractControl;

  filteredStates: Observable<any[]>;
  constructor(
    public dialogRef: MatDialogRef<AddGeoDistrictComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public store: List,
    public ds: DataService,
        public auth: AuthStore,
    private snackBar: MatSnackBar,
  ) { }

  async ngOnInit() {
    this.form = this.fb.group({
      code: [null, Validators.required],
      name: [null, Validators.required],
      province: [null, Validators.compose([Validators.required, validSelected.bind(this)])],
      description: [null],
    });
    this.code = this.form.controls['code'];
    this.name = this.form.controls['name'];
    this.description = this.form.controls['description'];
    this.province = this.form.controls["province"];
    //autocompleted
    const provinces = await this.ds.provinceRef().get().toPromise();
    this.filteredStates = autoComplete(this.province, pushToArray(provinces), 'name');
  }

  displayItem(item: any): string {
    return item ? item.name : item;
  }


  create(f: any, isNew: boolean) {
    if (this.form.valid) {
      this.form.disable()
      const { code, name, description, province } = f;
      const {country}=province;
      const item: IDistrict = {
        key: this.ds.createId(),
        page_key: pageKey(),
        created_date: new Date(),
        created_by: this.ds.collection('users').doc(`${this.auth.user.uid}`).ref,
        isDeleted: false,
        code:code,
        id: toNumber(code),
        name: name,
        description: description,
        status: statusObj.active,
        geoPoint: null,
        countryRef: this.ds.countryRef().doc(country.id).ref,
        provinceRef:this.ds.provinceRef().doc(province.key).ref,
      }
      this.store.save(this.ds.districtRef(), item, (success, res) => {
        if (success) {
          if (!isNew) {
            this.dialogRef.close();
          }
          this.snackBar.open('District has been created.', 'done', { duration: 3000 });
          this.form.reset();
          this.form.enable();
          this.inputRef.nativeElement.focus();
        } else {
          alert(res);
        }
      })
    }

  }

}
